import React from 'react';
import { PasslyDropzoneAreaComponent } from '@app/componentsV2';
import { useTypedTranslation } from '@app/hooks';

interface IReceivedData {
    returnFile: Function;
}

const UploadMigratorFileComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const handleChange = (fileUploaded: any) => {
        props.returnFile(fileUploaded);
    };

    return (
        <>
            <div className='migrateOnPrem__has-perm-drag-drop'>
                <p>{translation('ON_PREM_MIGRATOR_UPLOAD_INSTRUCTIONS')}</p>
                <PasslyDropzoneAreaComponent handleChange={handleChange}/>
            </div>
        </>
    );
};

export default UploadMigratorFileComponent;
